import { FC } from 'react';
import { Button, InlineLoading, InlineNotification } from '@carbon/react';
import { Download } from '@carbon/react/icons';
import { useAtomValue, useSetAtom } from 'jotai';
import { sessionResourceAtom } from 'atoms/root';
import { useServerExport } from 'lib/hooks/useServerExport';
import {
  EXPORT_COMPLETE_EVENT,
  exportUnitWellAssignmentsAtom,
  latestUnitWellAssignmentsAtom,
} from './atoms';
import styles from './page.module.scss';

// Exports every row the active filters match, server-side: the endpoint only
// acknowledges, and the finished CSV's link arrives over Pusher on the user's
// export channel, then downloads.
export const ExportCsvButton: FC = () => {
  const startOnServer = useSetAtom(exportUnitWellAssignmentsAtom);
  const userId = useAtomValue(sessionResourceAtom)?.id;
  // Nothing to export: no rows match, or the page could not load them.
  const matching =
    useAtomValue(latestUnitWellAssignmentsAtom)?.stats.total ?? 0;
  const { exportStatus, startExport, isExporting } = useServerExport({
    channel: userId ? `user_${userId}_exports` : null,
    event: EXPORT_COMPLETE_EVENT,
    exportFn: () => startOnServer(),
  });

  return (
    <div className={styles.exportAction}>
      {isExporting ? (
        <InlineLoading status="active" description="Exporting…" />
      ) : (
        <Button
          kind="tertiary"
          size="md"
          renderIcon={Download}
          disabled={!userId || matching === 0}
          onClick={() => startExport()}
        >
          Export CSV
        </Button>
      )}
      {exportStatus.status === 'failed' && (
        <InlineNotification
          kind="error"
          lowContrast
          hideCloseButton
          title="Could not export"
          subtitle={exportStatus.error ?? 'Please try again.'}
        />
      )}
    </div>
  );
};
